import React, { useEffect, useState } from "react"
import { Container, Row, Col } from "react-bootstrap"
import { Link } from "gatsby"
import FooterForm from "./Forms/FooterForm"
import * as styles from "./Header.module.css"

const Footer = () => {
  const [isIndexPage, setIsIndexPage] = useState(false)
  useEffect(() => {
    const handleHash = () => {
      const hash = window.location.hash
      if (hash) {
        const tab = document.querySelector(`a[href="${hash}"]`)
        if (tab) tab.click()
      }
    }

    window.addEventListener("load", handleHash)

    return () => {
      window.removeEventListener("load", handleHash)
    }
  }, [])

  useEffect(() => {
    if (typeof window !== "undefined") {
      setIsIndexPage(window.location.pathname === "/")
    }
  }, [])
  return (
    <footer className="py-0">
      <div className="footer-top">
        <Container>
          <Row>
            {/* New York Office */}
            <Col md={5}>
              <div className="footer-tp-sec">
                <div className="footer-title">New York Office</div>
                <p className="mb-0">475 Park Avenue S, 31st Floor</p>
                <p className="mb-0">New York, NY 10016</p>
                <p className="mt-0">212-256-9890</p>
              </div>
              {/* London Office */}
              <div className="footer-tp-sec">
                <div className="footer-title">London Office</div>
                <p className="mb-0">30 Dukes Pl</p>
                <p className="mb-0"> London EC3A 7LP</p>
                <p> +44 203440 4553</p>
              </div>
            </Col>

            {/* Contact Us */}
            <Col md={3}>
              <div className="footer-tp-sec">
                <div className="footer-title">Contact Us</div>
                <p className="email-address mb-3">
                  <svg xmlns="http://www.w3.org/2000/svg"
                       viewBox="0 0 512 512"
                       fill="white"
                       className={styles.iconSocial}>
                    <path
                      d="M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48L48 64zM0 176L0 384c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-208L294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176z" />
                  </svg>
                  <a
                    target="_blank"
                    href="mailto:info@mill-all.com"
                    className="text-decoration-none mx-2"
                  >
                    info@mill-all.com
                  </a>
                </p>
                <p className="email-address">
                  <svg xmlns="http://www.w3.org/2000/svg"
                       viewBox="0 0 512 512"
                       fill="white"
                       className={styles.iconSocial}>
                    <path
                      d="M164.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368C234.3 334.7 177.3 277.7 144 207.3L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96z" />
                  </svg>
                  <a
                    target="_blank"
                    href="tel:212-256-9890"
                    className="text-decoration-none mx-2"
                  >
                    212-256-9890
                  </a>
                </p>
              </div>

              {/* Social Media Links */}
              <div className="footer-tp-sec">
                <div className="footer-title">Join The Conversation</div>
                <ul className="social-media mb-0">
                  <li>
                    <a
                      href="https://www.linkedin.com/company/the-millennium-alliance"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="linkedin link"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 448 512"
                        fill="white"
                        className={styles.iconSocial}
                      >
                        <path d="M100.3 448H7.4V148.9h92.9zM53.8 108.1C24.1 108.1 0 83.5 0 53.8a53.8 53.8 0 0 1 107.6 0c0 29.7-24.1 54.3-53.8 54.3zM447.9 448h-92.7V302.4c0-34.7-.7-79.2-48.3-79.2-48.3 0-55.7 37.7-55.7 76.7V448h-92.8V148.9h89.1v40.8h1.3c12.4-23.5 42.7-48.3 87.9-48.3 94 0 111.3 61.9 111.3 142.3V448z" />
                      </svg>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://twitter.com/Mill_All"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="twitter link"
                    >
                      <svg
                        className={styles.iconSocialX}
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{ fontSize: "larger" }}
                      >
                        <path
                          d="M8.15281 5.92812L13.2525 0H12.0439L7.616 5.14719L4.07925 0H0L5.34822 7.78356L0 14H1.20859L5.88481 8.56439L9.61975 14H13.699L8.15248 5.92812H8.15281ZM6.49753 7.85203L5.95558 7.077L1.64402 0.909781H3.50033L6.97966 5.887L7.5215 6.66203L12.0445 13.1316H10.1884L6.49753 7.85236V7.85203Z"
                          fill="white"
                        ></path>
                      </svg>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.youtube.com/channel/UCJgFlsBHBF2u7Dl28seltUA/feed"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="youtube link"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 576 512"
                        fill="white"
                        className={styles.iconSocial}
                      >
                        <path d="M549.7 124.1c-6.3-23.7-24.8-42.3-48.3-48.6C458.8 64 288 64 288 64S117.2 64 74.6 75.5c-23.5 6.3-42 24.9-48.3 48.6-11.4 42.9-11.4 132.3-11.4 132.3s0 89.4 11.4 132.3c6.3 23.7 24.8 41.5 48.3 47.8C117.2 448 288 448 288 448s170.8 0 213.4-11.5c23.5-6.3 42-24.2 48.3-47.8 11.4-42.9 11.4-132.3 11.4-132.3s0-89.4-11.4-132.3zm-317.5 213.5V175.2l142.7 81.2-142.7 81.2z" />
                      </svg>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.facebook.com/MillenniumAlliance"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="facebook link"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 320 512"
                        fill="white"
                        className={styles.iconSocial}
                      >
                        <path d="M80 299.3V512H196V299.3h86.5l18-97.8H196V166.9c0-51.7 20.3-71.5 72.7-71.5c16.3 0 29.4 .4 37 1.2V7.9C291.4 4 256.4 0 236.2 0C129.3 0 80 50.5 80 159.4v42.1H14v97.8H80z" />
                      </svg>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.instagram.com/millennium_alliance/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="instagram link"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 448 512"
                        fill="white"
                        className={styles.iconSocial}
                      >
                        <path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z" />
                      </svg>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.tiktok.com/@mill_all"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="tiktok link"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 448 512"
                        fill="white"
                        className={styles.iconSocial}
                      >
                        <path d="M448 209.9a210.1 210.1 0 0 1 -122.8-39.3V349.4A162.6 162.6 0 1 1 185 188.3V278.2a74.6 74.6 0 1 0 52.2 71.2V0l88 0a121.2 121.2 0 0 0 1.9 22.2h0A122.2 122.2 0 0 0 381 102.4a121.4 121.4 0 0 0 67 20.1z" />
                      </svg>
                    </a>
                  </li>
                </ul>
                <p className="privacy-policy-menu text-decoration-none">
                  <Link to="/privacy-policy/" className="text-decoration-none">
                    Privacy Policy
                  </Link>
                </p>
              </div>
            </Col>

            {/* Form Section */}
            <Col md={4}>
              <div className="home-form">
                <div className="home-form-content">
                  {isIndexPage && (
                    <div className={`${styles.footerContactText} text-size-29`}>
                      Get the latest news on <br />
                      <strong> Digital Transformation &amp; Leadership</strong>
                    </div>
                  )}
                  <FooterForm />
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </footer>
  )
}

export default Footer
